import { LitElement, css, html } from "lit";

import { customElement, property } from "lit/decorators.js";

@customElement("wow-divider")
export class WowDivider extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      align-items: center;
      gap: var(--sds-size-space-300);
    }

    .divider-line {
      flex: 1;
      height: var(--sds-size-stroke-border);
      background-color: var(--sds-color-border-default-default);
    }

    .divider-text {
      font-family: var(--sds-typography-family-title);
      font-weight: var(--sds-typography-weight-semibold);
      font-size: var(--sds-typography-scale-01);
      line-height: 2;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: var(--sds-color-text-default-tertiary);
    }
  `;

  @property({ type: Boolean })
  simple = false;

  override render() {
    if (this.simple) {
      return html` <div class="divider-line"></div> `;
    }

    return html`
      <div class="divider-line"></div>
      <span class="divider-text">
        <slot></slot>
      </span>
      <div class="divider-line"></div>
    `;
  }
}
